import { Measurement, MeasurementProps } from "./Measurement";
import React, { FC } from "react";

/**
 * @returns a Measurement, wrapped to look good in a DataGrid
 **/
export const MeasurementCell: FC<MeasurementProps> = (props) => (
  <div className="align-center flex h-full justify-end w-full">
    <Measurement {...props} />
  </div>
);
